import React from 'react';
import { Input } from 'antd';

import { OptionItem } from '../../types';

import './index.less';

interface IProps {
  options: OptionItem[];
}

function CompletionOption({ options }: IProps) {
  return (
    <div className="manmade-completion-option">
      <ul className="ul">
        {
          options.map((item, index) => {
            return (
              <li key={index}>
                <div className="row">
                  <div className="number">{index + 1}</div>
                  <Input placeholder="请输入答案" value={item.blankAnswer} disabled />
                </div>
                <div className="row">
                  <div className="number">{index + 1}</div>
                  <span>{item.option}</span>
                </div>
              </li>
            )
          })
        }
      </ul>
    </div>
  )
}

export default CompletionOption;

